import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InventoriesState, InventoryWithValues } from './inventories.types';
import { ClientVariable } from '../../model/client-model/client-variable';
// import { MonetaryValueResponse } from '../../api/core/models/api/monetary-value-response';
// import { ValueResponse } from '../../api/core/models/api/value-response';

export const selectInventoriesState = createFeatureSelector<InventoriesState>('inventories');

export const selectBaselineInventory = createSelector(selectInventoriesState, (state): InventoryWithValues | null => {
  if (state.inventories === null) {
    return null;
  }
  for (const [_, inventory] of state.inventories) {
    if (inventory.isBaselineYear) {
      return inventory;
    }
  }
  return null;
});

export const selectInventories = createSelector(selectInventoriesState, (state) => state.inventories);

export const selectIsInventoriesLoading = createSelector(selectInventoriesState, (state) => state.inventoriesLoading);

export const selectInventoriesLoadingError = createSelector(
  selectInventoriesState,
  (state) => state.inventoriesLoadingError
);

export const selectVariableLogsByValueId = (valueId: ClientVariable['valueId']) => {
  return createSelector(selectInventoriesState, ({ variablesLogs }) => variablesLogs[valueId!] ?? null);
};

// export const selectMonetaryValuesByYear = (year: number) => {
//   return createSelector(selectInventories, (inventories) => {
//     if (!inventories) {
//       return [];
//     }

//     const result: MonetaryValueResponse[] = [];

//     Object.keys(inventories.monetaryVariablesValues).forEach((key) => {
//       const filteredValues = inventories.monetaryVariablesValues[key].filter((value) => value.inventoryYear === year);

//       result.push(...filteredValues);
//     });

//     return result;
//   });
// };

// export const selectVariableValuesByYear = (year: number) => {
//   return createSelector(selectInventories, (inventories) => {
//     if (!inventories) {
//       return [];
//     }

//     const result: ValueResponse[] = [];

//     Object.keys(inventories.variablesValues).forEach((key) => {
//       const filteredValues = inventories.variablesValues[key].filter((value) => value.inventoryYear === year);

//       result.push(...filteredValues);
//     });

//     return result;
//   });
// };

// export const selectAllVariablesByYear = (year: number) => {
//   return createSelector(selectInventories, (inventories) => {
//     if (!inventories) {
//       return [];
//     }

//     const result: (ValueResponse | MonetaryValueResponse)[] = [];

//     const allMergedValues = {
//       ...inventories.variablesValues,
//       ...inventories.monetaryVariablesValues,
//     };

//     Object.keys(allMergedValues).forEach((key) => {
//       const filteredValues = allMergedValues[key].filter((value) => value.inventoryYear === year);
//       result.push(...filteredValues);
//     });

//     return result;
//   });
// };

// deprecated selectors, moved from variables state
export const selectMonetaryVariableIds = createSelector(selectInventoriesState, (state) => state.monetaryVariableIds);
export const selectVariablesQueuedForSave = createSelector(
  selectInventoriesState,
  (state) => state.variablesQueuedForSave
);
export const selectVariablesSaving = createSelector(selectInventoriesState, (state) => state.variablesSaving);
export const selectVariableLastSaved = createSelector(selectInventoriesState, (state) => state.variableLastSaved);
